import { useEffect, useState } from "react";
import { GitBranch, CircleX, TriangleAlert, Sun, Moon, Check } from "lucide-react";
import { FILE_NAMES } from "./files";

export const StatusBar = ({ lang, setLang, theme, setTheme, activeSection }) => {
  const [ln, setLn] = useState(1);

  useEffect(() => {
    const el = document.getElementById("editor-scroll");
    if (!el) return;
    const onScroll = () => setLn(Math.floor(el.scrollTop / 28) + 1);
    el.addEventListener("scroll", onScroll, { passive: true });
    return () => el.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="ide-status-bar"
      className="h-7 shrink-0 flex items-center justify-between px-3 bg-[#FF5722] text-white font-mono text-[11px] select-none"
    >
      <div className="flex items-center gap-4">
        <span className="flex items-center gap-1.5" data-testid="status-branch">
          <GitBranch size={12} /> main
        </span>
        <span className="hidden sm:flex items-center gap-1">
          <CircleX size={12} /> 0 <TriangleAlert size={12} /> 0
        </span>
        <span className="hidden lg:flex items-center gap-1">
          <Check size={12} /> {FILE_NAMES[lang][activeSection]}
        </span>
      </div>
      <div className="flex items-center gap-4">
        <span className="hidden sm:inline" data-testid="status-ln">Ln {ln}, Col 1</span>
        <span className="hidden md:inline">UTF-8</span>
        <span className="hidden md:inline">{"{ React }"}</span>
        <span className="flex items-center gap-1.5" data-testid="status-lang-toggle">
          <button
            data-testid="lang-tr-btn"
            onClick={() => setLang("tr")}
            className={`transition-opacity ${lang === "tr" ? "font-bold underline underline-offset-2" : "opacity-60 hover:opacity-100"}`}
          >
            TR
          </button>
          <span className="opacity-50">/</span>
          <button
            data-testid="lang-en-btn"
            onClick={() => setLang("en")}
            className={`transition-opacity ${lang === "en" ? "font-bold underline underline-offset-2" : "opacity-60 hover:opacity-100"}`}
          >
            EN
          </button>
        </span>
        <button
          data-testid="theme-toggle-btn"
          onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
          className="hover:scale-110 transition-transform"
          aria-label="Toggle theme"
        >
          {theme === "dark" ? <Sun size={13} /> : <Moon size={13} />}
        </button>
      </div>
    </div>
  );
};
